module.exports = __webpack_public_path__ + "media/home-page/no-risk-b0a264d0.svg";